export const EXPAND_ALL = 'Expand'
export const COLLAPSE_ALL = 'Collapse'
